import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-header-login',
  templateUrl: './header-login.component.html',
  styleUrls: ['./header-login.component.css'],
})
export class HeaderLoginComponent implements OnInit {
  private _observers: Subscription = new Subscription();
  public url = '';

  constructor(private router: Router, public route: ActivatedRoute) {}

  ngOnInit(): void {
    this.url = this.router.url;

    this.setObservers();
  }

  setObservers(): void {
    this._observers.add(this.routerObserver());
  }

  routerObserver(): Subscription {
    return this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.url = (e as NavigationEnd).url;
      });
  }
}
